import { render, staticRenderFns } from "./add-process.vue?vue&type=template&id=33261c0e&scoped=true&"
import script from "./add-process.vue?vue&type=script&lang=js&"
export * from "./add-process.vue?vue&type=script&lang=js&"
import style0 from "./add-process.vue?vue&type=style&index=0&id=33261c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33261c0e",
  null
  
)

export default component.exports